import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20artistic%20overhead%20flat%20lay%20of%20fashion%20accessories%20and%20textile%20swatches%20arranged%20in%20an%20organic%20circular%20composition%20on%20textured%20oatmeal%20linen%20background%2C%20soft%20diffused%20morning%20light%20from%20large%20window%2C%20carefully%20placed%20terracotta%20ceramic%20vase%20with%20dried%20pampas%20grass%2C%20neutral%20cream%20beige%20and%20warm%20sand%20color%20palette%2C%20editorial%20lifestyle%20photography%20with%20abundant%20negative%20space%20and%20organic%20texture%20details&width=1800&height=1000&seq=hero-bg-cssbuy-v3&orientation=landscape"
        alt="CSSBuy spreadsheet lifestyle background"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/15 via-black/10 to-background-50/95"></div>

      <div className="relative z-10 w-full max-w-[900px] mx-auto px-4 md:px-6 text-center pt-20 pb-10">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/80 backdrop-blur-sm border border-background-200/50 mb-6">
          <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
          <span className="text-xs font-medium text-foreground-700 font-label">Updated Weekly &mdash; 2026 Edition</span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-extrabold text-background-50 leading-[1.08] mb-4 md:mb-5 tracking-tight">
          Best CSSBuy Spreadsheet<br />
          <span className="text-accent-300">&amp; Proxy Shopping Lists</span>
        </h1>

        <p className="text-sm md:text-base text-background-50/80 max-w-[600px] mx-auto mb-8 font-body leading-relaxed">
          Discover the most updated <strong>CSSBuy spreadsheet</strong>, Kakobuy spreadsheet, Superbuy spreadsheet, and Oopbuy spreadsheet lists. Compare trusted sellers, save money, and shop smarter with verified proxy shopping data.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer font-label"
          >
            CSSBuy Sheet
            <i className="ri-arrow-right-up-line text-base"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-background-50/90 backdrop-blur-sm text-foreground-950 text-sm font-semibold rounded-full hover:bg-background-50 transition-all duration-200 whitespace-nowrap cursor-pointer font-label border border-background-200/30"
          >
            Buy It Now
            <i className="ri-shopping-bag-line text-base"></i>
          </a>
          <Link
            to="/article/best-cssbuy-spreadsheet-guide-2026"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-transparent border border-background-50/30 text-background-50 text-sm font-medium rounded-full hover:bg-background-50/10 transition-all duration-200 whitespace-nowrap cursor-pointer font-label"
          >
            Read Full Guide
            <i className="ri-arrow-right-line text-base"></i>
          </Link>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2">
        <a href="#categories" className="flex flex-col items-center gap-2 text-background-50/60 hover:text-background-50 transition-colors cursor-pointer">
          <span className="text-[10px] uppercase tracking-widest font-label">Scroll</span>
          <i className="ri-arrow-down-line text-lg animate-bounce"></i>
        </a>
      </div>
    </section>
  );
}